/**
 * Latest offers slide-in drawer.
 *
 * A trigger tab opens a right-side panel of the newest casino offers (rendered
 * server-side by CWP\Hooks\LatestOffers). Auto-opens at most once per day so it
 * isn't nagging; the trigger reopens it anytime. Dismissal is remembered in
 * localStorage.
 */
export const cwpLatestOffers = {
	init() {
		const drawer = document.querySelector('[data-cwp-latest-offers]');
		if (!drawer) {
			return;
		}

		const trigger = document.querySelector('[data-cwp-lo-open]');
		const backdrop = document.querySelector('[data-cwp-lo-backdrop]');
		const closeBtn = drawer.querySelector('[data-cwp-lo-close]');

		let userClosed = false;
		const isOpen = () => drawer.classList.contains('is-open');

		const open = () => {
			drawer.hidden = false;
			if (backdrop) backdrop.hidden = false;
			requestAnimationFrame(() => {
				drawer.classList.add('is-open');
				if (backdrop) backdrop.classList.add('is-open');
			});
			if (trigger) trigger.setAttribute('aria-expanded', 'true');
			document.body.classList.add('cwp-lo-open');
		};

		const close = () => {
			userClosed = true;
			drawer.classList.remove('is-open');
			if (backdrop) backdrop.classList.remove('is-open');
			if (trigger) trigger.setAttribute('aria-expanded', 'false');
			document.body.classList.remove('cwp-lo-open');
			try {
				localStorage.setItem('cwpLoDismissed', String(Date.now()));
			} catch (e) {
				/* ignore */
			}
			setTimeout(() => {
				drawer.hidden = true;
				if (backdrop) backdrop.hidden = true;
			}, 340);
		};

		if (trigger) {
			trigger.addEventListener('click', () => (isOpen() ? close() : open()));
		}
		if (closeBtn) {
			closeBtn.addEventListener('click', close);
		}
		if (backdrop) {
			backdrop.addEventListener('click', close);
		}
		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && isOpen()) {
				close();
			}
		});

		// Auto-open behaviour from the settings (Settings → Latest Offers).
		const mode = drawer.dataset.autoOpen || 'daily';
		const delayMs = (parseInt(drawer.dataset.delay || '12', 10) || 0) * 1000;
		const dayMs = 24 * 60 * 60 * 1000;

		let shouldAuto = false;
		if (mode === 'always') {
			shouldAuto = true;
		} else if (mode === 'daily') {
			let dismissed = 0;
			try {
				dismissed = parseInt(localStorage.getItem('cwpLoDismissed') || '0', 10);
			} catch (e) {
				dismissed = 0;
			}
			shouldAuto = Date.now() - dismissed > dayMs;
		}

		if (shouldAuto) {
			setTimeout(() => {
				if (!isOpen() && !userClosed) {
					open();
				}
			}, delayMs);
		}

		// The trigger's clearance above the sticky offer bars comes from
		// --cwp-bottom-bar-h, published by initBottomBarHeight() in main.js.
	},
};
